import React from "react";
import DashboardNav from "./Components/DashboardNav/DashboardNav";
import GooLoader from "../../Components/GooLoader/GooLoader";
import MenuBar from "./Components/MenuBar/MenuBar";
import SuccessBox from "../../Components/SuccessBox/SuccessBox";
import ErrorBox from "../../Components/ErrorBox/ErrorBox";
import Tab from "./Components/Tabs/Tab";
import jwt_decode from "jwt-decode";
import call from "../../API/API";
import { Helmet } from "react-helmet-async";

import "./Dashboard.css";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {},
      menuOpen: false,
      windowWidth: 0,
      isLoading: true,
      successBoxTitle: "",
      successBoxBody: "",
      errorBoxBody: "",
      errorBoxTitle: "",
    };

    this.showErrorBox = this.showErrorBox.bind(this);
    this.showSuccessBox = this.showSuccessBox.bind(this);
    this.handleMenuChange = this.handleMenuChange.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleSideBarLinkClick = this.handleMenuChange.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
    this.handleNameUpdate = this.handleNameUpdate.bind(this);
    this.handleLastNameUpdate = this.handleLastNameUpdate.bind(this);
    this.startLoading = this.startLoading.bind(this);
    this.stopLoading = this.stopLoading.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (!decoded.active) {
        this.props.history.push("/");
      } else {
        call.users_API
          .getPersonalUserMatchingCriteria()
          .then((response) => {
            if (response.success) {
              let userData = response.results;
              this.setState(
                {
                  userInfo: {
                    name: userData.name,
                    lastname: userData.lastname,
                  },
                },
                () => {
                  this.setState({
                    isLoading: false,
                  });
                }
              );
            } else {
              this.props.history.push("/error", { error: response.results });
            }
          })
          .catch((err) => {
            this.props.history.push("/error", { error: err.message });
          });
      }
    }
  }

  startLoading() {
    this.setState({
      isLoading: true,
    });
  }

  stopLoading() {
    this.setState({
      isLoading: false,
    });
  }

  showSuccessBox(title, message) {
    this.setState(
      {
        successBoxTitle: title,
        successBoxBody: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            successBoxTitle: "",
            successBoxBody: "",
          });
        }, 3000);
      }
    );
  }

  showErrorBox(title, message) {
    this.setState(
      {
        errorBoxTitle: title,
        errorBoxBody: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            errorBoxTitle: "",
            errorBoxBody: "",
          });
        }, 3000);
      }
    );
  }

  handleNameUpdate(newName) {
    this.setState((prevState) => ({
      userInfo: {
        ...prevState.userInfo,
        name: newName,
      },
    }));
  }

  handleLastNameUpdate(newLastName) {
    this.setState((prevState) => ({
      userInfo: {
        ...prevState.userInfo,
        lastname: newLastName,
      },
    }));
  }

  handleResize() {
    this.setState({
      windowWidth: window.outerWidth,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleMenuChange() {
    const menuIsOpen = this.state.menuOpen;
    if (menuIsOpen) {
      this.setState({
        menuOpen: false,
      });
    } else {
      this.setState({
        menuOpen: true,
      });
    }
  }

  handleSideBarLinkClick(e) {
    e.preventDefault();
    if (this.state.windowWidth < 1024) {
      this.handleMenuChange();
    }
  }

  handleSignOut(e) {
    e.preventDefault();
    let token = localStorage.getItem("token");
    if (token) {
      localStorage.clear();
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <div className="dashboard">
        {this.state.isLoading ? <GooLoader /> : null}
        <header>
          <MenuBar
            handleMenuChange={this.handleMenuChange}
            menuIsOpen={this.state.menuOpen}
            windowWidth={this.state.windowWidth}
          />
          <DashboardNav
            menuIsOpen={this.state.menuOpen}
            handleSideBarLinkClick={this.handleSideBarLinkClick}
            handleSignOut={this.handleSignOut}
          />
        </header>
        <main>
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>
          <Tab
            showErrorBox={this.showErrorBox}
            showSuccessBox={this.showSuccessBox}
            userName={this.state.userInfo.name}
            userLastName={this.state.userInfo.lastname}
            match={this.props.match}
            menuIsOpen={this.state.menuOpen}
            handleNameUpdate={this.handleNameUpdate}
            handleLastNameUpdate={this.handleLastNameUpdate}
          />
        </main>
        <SuccessBox
          title={this.state.successBoxTitle}
          body={this.state.successBoxBody}
        />
        <ErrorBox
          title={this.state.errorBoxTitle}
          body={this.state.errorBoxBody}
        />
      </div>
    );
  }
}

export default Dashboard;
